export const TWITTER_URL = 'https://x.com/';

export const LIVE_DEMO_URL = 'https://meetings.hubspot.com/academix';
export const ONBOARDING_FORM_URL = 'https://form.typeform.com/to/kty6ri6T';

export const SAMPLE_PAPER_1_URL =
  'https://drive.google.com/file/d/1BlJHNGWcFuABKrz9Zibsr_zzidlO1Q-C/view?usp=drive_link';

export const SAMPLE_PAPER_2_URL =
  'https://drive.google.com/file/d/1BL6ky5eOIOuAmOO_FjZdDuzUPnlqMRoQ/view?usp=drive_link';

export const SAMPLE_CHINESE_PAPER_URLS = [
  'https://storage.googleapis.com/academix-dev-content/Chinese/Chinese%20Writing%20Sample%201.pdf',
  'https://storage.googleapis.com/academix-dev-content/Chinese/Chinese%20Writing%20Sample%202.pdf',
  'https://storage.googleapis.com/academix-dev-content/Chinese/Chinese%20Writing%20Sample%203.pdf',
  'https://storage.googleapis.com/academix-dev-content/Chinese/Chinese%20Writing%20Sample%204.pdf',
  'https://storage.googleapis.com/academix-dev-content/Chinese/Chinese%20Writing%20Sample%205.pdf',
  'https://storage.googleapis.com/academix-dev-content/Chinese/Chinese%20Writing%20Sample%206.pdf',
];
export const SAMPLE_ENGLISH_PAPER_URLS = [
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20A1%20(checked).pdf',
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20A2%20(checked).pdf',
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20B1_1%20(checked).pdf',
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20B1_2%20(checked).pdf',
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20B2_1%20(checked).pdf',
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20B2_3%20(checked).pdf',
];
export const SAMPLE_ENGLISH_PAPER_A_URLS = [
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20A1.pdf',
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20A2.pdf',
];
export const SAMPLE_ENGLISH_PAPER_B1_URLS = [
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20B1_1.pdf',
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20B1_2.pdf',
];
export const SAMPLE_ENGLISH_PAPER_B2_URLS = [
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20B2_1.pdf',
  'https://storage.googleapis.com/academix-dev-content/English/DSE%20Reading%20Sample%20B2_3.pdf',
];

export const WHATSAPP_API_URL = 'https://api.whatsapp.com/send?phone=85290321409';
export const CHATBOT_PROFILE_PICTURE = 'https://avatar.iran.liara.run/public/99';
export const CHATBOT_PROFILE_PICTURE_2 = 'https://avatar.iran.liara.run/public/48';
export const SUPPORT_URL = 'https://forms.gle/wrMzxYKa47sy1kZk9';
export const FEEDBACK_FORM_URL = 'https://forms.gle/wrMzxYKa47sy1kZk9';